import { PageSectionCommonProps } from './PageSectionCommonProps'

import * as SC from './styles'

export const PageSectionCommon = (props: PageSectionCommonProps) => {
  const { contentPaddings = true, children } = props

  return <SC.Content $hasPaddings={contentPaddings}>{children}</SC.Content>
}
